module.exports = __webpack_public_path__ + "auth-facebook.svg";